export default "__VITE_ASSET__C4C6pqWI__"